import { Colors } from "themes/color-palette";

export const Semantic = {
  Text: {
    primary: Colors.white,
    secondary: Colors.gray["400"],
    informational: Colors.blue["500"],
    positive: Colors.green["500"],
    negative: Colors.red["500"]
  },
  Background: {
    primary: Colors.black,
    secondary: Colors.gray["900"],
    tertiary: Colors.gray["800"],
    informational: Colors.blue["500"],
    positive: Colors.green["600"],
    warning: Colors.yellow["500"],
    negative: Colors.red["600"],
    informationalSubtle: Colors.blue["50"],
    positiveSubtle: Colors.green["50"],
    warningSubtle: Colors.yellow["50"],
    negativeSubtle: Colors.red["50"]
  },
  Border: {
    primary: Colors.gray["800"],
    secondary: Colors.gray["700"],
    negative: Colors.red["500"]
  },
  DataVisualization: {
    positive: Colors.green["500"],
    negative: Colors.red["500"]
  }
};
